"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMediaVideo = exports.StyledMediaImage = exports.CROP_TYPE = exports.CLOUDINARY_VIDEO_BASE_URL = void 0;
exports.addDefaultFlagsToCloudinaryUrl = addDefaultFlagsToCloudinaryUrl;
exports["default"] = void 0;
exports.generateCroppedUrl = generateCroppedUrl;
exports.generateUrl = generateUrl;
exports.getCloudinaryPathFromCloudinaryUrl = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _cloudinaryReact = require("cloudinary-react");
var _cloudinaryCore = _interopRequireDefault(require("cloudinary-core"));
var _shared = require("../../utils/shared.utils");
var _excluded = ["mediaElementId", "children", "path", "className", "width", "height", "x", "y", "crop", "fetchFormat", "flags", "quality", "mediaRef", "resizeValues", "flagsToRemove", "lazyLoad", "restartGif", "onClick", "poster", "transformations", "alt", "isFromLightbox", "gravity"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CLOUDINARY_VIDEO_BASE_URL = exports.CLOUDINARY_VIDEO_BASE_URL = 'https://res.cloudinary.com/honeybook/video/upload';
var getCloudinaryPathFromCloudinaryUrl = exports.getCloudinaryPathFromCloudinaryUrl = function getCloudinaryPathFromCloudinaryUrl(url) {
  var CLOUDINARY_URL_REGEX = /^(https?:\/\/res.cloudinary.com\/honeybook\/image\/upload\/v[0-9]+\/)(.*)$/;
  // this regex should also match cloudinary urls with transformations
  var CLOUDINARY_URL_WITH_TRANSFORMATIONS_REGEX = /^(https?:\/\/res.cloudinary.com\/honeybook\/image\/upload\/w_[0-9]+,h_[0-9]+\/v[0-9]+\/)(.*)$/;
  var _ref = url.split(CLOUDINARY_URL_REGEX) || [],
    _ref2 = (0, _slicedToArray2["default"])(_ref, 3),
    cloudinaryPath = _ref2[2];
  var _ref3 = url.split(CLOUDINARY_URL_WITH_TRANSFORMATIONS_REGEX) || [],
    _ref4 = (0, _slicedToArray2["default"])(_ref3, 3),
    cloudinaryWithTransformPath = _ref4[2];
  return cloudinaryPath || cloudinaryWithTransformPath;
};
function addDefaultFlagsToCloudinaryUrl(url) {
  var transformations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [{
    fetchFormat: 'auto',
    flags: 'lossy'
  }];
  if (!url) {
    return null;
  }
  var cloudinaryPath = getCloudinaryPathFromCloudinaryUrl(url);
  // @ts-ignore
  var cloudinaryCore = new _cloudinaryCore["default"].Cloudinary({
    cloud_name: 'honeybook'
  });
  return cloudinaryCore.url(cloudinaryPath, {
    transformation: transformations
  });
}
function generateCroppedUrl(url, _ref5) {
  var width = _ref5.width,
    height = _ref5.height,
    x = _ref5.x,
    y = _ref5.y,
    crop = _ref5.crop;
  var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cloudinaryPath = url;
  if ((0, _shared.isUrl)(cloudinaryPath)) {
    // For crop transformations to work, path cannot be absolute
    cloudinaryPath = getCloudinaryPathFromCloudinaryUrl(url);
  }

  // @ts-ignore
  var cloudinaryCore = new _cloudinaryCore["default"].Cloudinary({
    cloud_name: 'honeybook'
  });
  return cloudinaryCore.url(cloudinaryPath, _objectSpread({
    width: width,
    height: height,
    x: x,
    y: y,
    crop: crop
  }, flags));
}
// this is a more generic version of url generation
// when we refactor this component and upgrade to @cloudinary-core we'll can
// define wrapper functions for this with common uses
function generateUrl(_ref6) {
  var path = _ref6.path,
    transformations = _ref6.transformations;
  // @ts-ignore
  var cloudinaryCore = new _cloudinaryCore["default"].Cloudinary({
    cloud_name: 'honeybook'
  });
  return cloudinaryCore.url(path, {
    transformation: transformations
  });
}
var CROP_TYPE = exports.CROP_TYPE = ['fill', 'lfill', 'fill_pad', 'crop', 'thumb', 'scale', 'limit', 'fit', 'm_fit', 'pad', 'l_pad', 'm_pad'];
var CLOUD_NAME = 'honeybook';
function useFlags(isSVG, isVideo, fetchFormat, quality, flags, flagsToRemove) {
  var shouldAddFlags = !(isSVG || isVideo);
  return (0, _react.useMemo)(function () {
    var mediaElementFlags = shouldAddFlags ? {
      fetchFormat: fetchFormat || 'auto',
      quality: quality || 'auto',
      flags: flags || 'lossy'
    } : {};
    flagsToRemove.forEach(function (flagToRemove) {
      Reflect.deleteProperty(mediaElementFlags, flagToRemove);
    });
    return mediaElementFlags;
  }, [fetchFormat, flags, flagsToRemove, quality, shouldAddFlags]);
}
function useGifRestart(path, shouldRestart) {
  // Changing the image src after the initial render is enough to restart the gif
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _path = _useState2[0],
    setPath = _useState2[1];
  (0, _react.useEffect)(function () {
    return setPath(path);
  }, [path]);
  return shouldRestart ? _path : path;
}
function ConditionalCloudinaryContext(_ref7) {
  var children = _ref7.children,
    className = _ref7.className,
    onClick = _ref7.onClick;
  var isWrappedWithCloudinaryContext = (0, _react.useContext)(_cloudinaryReact.CloudinaryContext.contextType);
  if (!!isWrappedWithCloudinaryContext) {
    // Backwards compatibility for places that passed in className and onClick
    if (className || onClick) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        onClick: onClick
      }, children);
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }
  return /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.CloudinaryContext, {
    secure: true,
    cloudName: CLOUD_NAME,
    className: className,
    onClick: onClick
  }, children);
}
var HBMediaElement = function HBMediaElement(_ref8) {
  var mediaElementId = _ref8.mediaElementId,
    children = _ref8.children,
    path = _ref8.path,
    className = _ref8.className,
    width = _ref8.width,
    height = _ref8.height,
    x = _ref8.x,
    y = _ref8.y,
    crop = _ref8.crop,
    fetchFormat = _ref8.fetchFormat,
    flags = _ref8.flags,
    quality = _ref8.quality,
    mediaRef = _ref8.mediaRef,
    resizeValues = _ref8.resizeValues,
    _ref8$flagsToRemove = _ref8.flagsToRemove,
    flagsToRemove = _ref8$flagsToRemove === void 0 ? [] : _ref8$flagsToRemove,
    lazyLoad = _ref8.lazyLoad,
    restartGif = _ref8.restartGif,
    onClick = _ref8.onClick,
    poster = _ref8.poster,
    _ref8$transformations = _ref8.transformations,
    transformations = _ref8$transformations === void 0 ? [] : _ref8$transformations,
    alt = _ref8.alt,
    isFromLightbox = _ref8.isFromLightbox,
    gravity = _ref8.gravity,
    props = (0, _objectWithoutProperties2["default"])(_ref8, _excluded);
  var lastIndex = path === null || path === void 0 ? void 0 : path.lastIndexOf('.');
  var fileName = path === null || path === void 0 ? void 0 : path.slice(0, lastIndex);
  var fileExtension = path === null || path === void 0 ? void 0 : path.slice(lastIndex + 1);
  var isSVG = fileExtension === 'svg';
  var isVideo = ['mp4', 'webm', 'mov'].includes(fileExtension);
  var MediaComponent = isVideo ? StyledMediaVideo : StyledMediaImage;
  var flagProps = useFlags(isSVG, isVideo, fetchFormat, quality, flags, flagsToRemove);
  var _path = isVideo ? fileName : path;
  _path = useGifRestart(_path, restartGif);
  if ((0, _shared.isUrl)(_path)) {
    // For crop transformations to work, path cannot be absolute
    if (isFromLightbox) {
      _path = getCloudinaryPathFromCloudinaryUrl(_path) || _path;
    } else {
      _path = getCloudinaryPathFromCloudinaryUrl(_path);
    }
  }
  var _poster = poster ? "".concat(CLOUDINARY_VIDEO_BASE_URL, "/").concat(poster) : undefined;
  return /*#__PURE__*/_react["default"].createElement(ConditionalCloudinaryContext, {
    className: className,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(MediaComponent, (0, _extends2["default"])({
    id: mediaElementId,
    publicId: _path,
    width: resizeValues ? resizeValues.width : width,
    height: resizeValues ? resizeValues.height : height
  }, flagProps, {
    innerRef: mediaRef,
    loading: lazyLoad ? 'lazy' : undefined,
    poster: _poster
  }, props, {
    alt: alt || _path
  }), crop && /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Transformation, {
    crop: crop,
    width: width,
    height: height,
    x: x,
    y: y,
    gravity: gravity
  }), transformations.map(function (transformation, index) {
    return /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Transformation, (0, _extends2["default"])({
      key: index
    }, transformation));
  })), children);
};
var _default = exports["default"] = HBMediaElement;
var StyledMediaImage = exports.StyledMediaImage = (0, _styledComponents["default"])(_cloudinaryReact.Image).withConfig({
  displayName: "HBMediaElement__StyledMediaImage",
  componentId: "sc-i8kgfy-0"
})([""]);
var StyledMediaVideo = exports.StyledMediaVideo = (0, _styledComponents["default"])(_cloudinaryReact.Video).withConfig({
  displayName: "HBMediaElement__StyledMediaVideo",
  componentId: "sc-i8kgfy-1"
})([""]);
//# sourceMappingURL=HBMediaElement.js.map